import React, { FC, memo, useEffect, useState } from 'react';
import { box } from 'tweetnacl';
import { decrypt, toChatDisplayText } from '../../util/crypto';
import { decodeBase64 } from 'tweetnacl-util';
import { formatTimeOrRelative } from '../../util/date-utils';
import i18next from 'i18next';
import emoji from 'to-emoji';
import ErrorIcon from '../../assets/error-icon.svg?react';
import { useChat } from '../../contexts/chat-context';

type Props = {
  message: any, therapist: any,
  resendMessage: (text: string) => void;
};

const ChatMessage: FC<Props> = ({ message, therapist, resendMessage }) => {
  const { tKeyPair, patientPublicKey } = useChat();
  const [isTimeoutReached, setTimeoutReached] = useState(false);
  const messageClass = message && message.senderId === therapist._id ? 'right' : 'left';
  
  if (!patientPublicKey || !tKeyPair) {
    return null;
  }
  
  const finalKeyTherapist = box.before(decodeBase64(patientPublicKey), tKeyPair.secretKey);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutReached(true);
    }, 5000);

    return (): void => clearTimeout(timer);
  }, [message.ackId]);
    
  const isSendingFailed: boolean = Boolean(message.ackId) && isTimeoutReached;

  if (messageClass === 'left') {
    return (
      <div className="d-flex flex-column align-items-start flex-shrink-0 mb-2">
        <div
          className="py-2 px-3"
          style={{ maxWidth: '70%', borderRadius: '1.25rem', backgroundColor: '#dee4e9', color: '#000' }}>
          <p
            className="mb-0"
            style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>
            {emoji.emoticonToEmoji(toChatDisplayText(decrypt(finalKeyTherapist, message.text)))}
          </p>
          <p className="small text-nowrap mb-0 text-end" style={{ opacity: 0.6 }}>
            {formatTimeOrRelative(message.createdAt)}
          </p>
        </div>
      </div>);
  } else {
    return (
      <>
        <div
          className="d-flex flex-column align-items-end flex-shrink-0 mb-2"
          onClick={() => { if (message.ackId) {resendMessage(decrypt(finalKeyTherapist, message.text));} }}>
          <div
            className="py-2 px-3"
            style={{
              maxWidth: '70%',
              borderRadius: '1.25rem',
              color: '#fff3f5',
              backgroundColor: isSendingFailed ? 'rgba(255, 105, 95, 0.5)' : '#002b4b',
              filter: isSendingFailed ? 'blur(0.2px)' : undefined,
            }}>
            <p
              className="mb-0"
              style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>
              {emoji.emoticonToEmoji(toChatDisplayText(decrypt(finalKeyTherapist, message.text)))}
            </p>
            <p className="small text-nowrap mb-0 text-end" style={{ opacity: 0.6 }}>
              {formatTimeOrRelative(message.createdAt)}
              {message.ackId && !isTimeoutReached ? <span><i className="fas fa-spin fa-spinner ms-2" /></span> : null}</p>
          </div>
          {isSendingFailed ?
            <p className="small text-nowrap text-primary fw-semibold mt-1 mb-0">
              {i18next.t('chat.sendingFailed')} <ErrorIcon width={12} height={12} />
            </p> : null}
        </div>
      </>);
  }
};

export default memo(ChatMessage);
